import { Language } from '../types/language';

interface GeoResponse {
  country_code: string;
  country_name: string;
  ip: string;
}

const COUNTRY_LANGUAGE_MAP: Record<string, Language> = {
  // East Asia
  CN: 'zh', // China
  TW: 'zh', // Taiwan
  HK: 'zh', // Hong Kong
  MO: 'zh', // Macau
  KR: 'ko', // South Korea
  
  // Russian-speaking countries
  RU: 'ru', // Russia
  BY: 'ru', // Belarus
  KZ: 'ru', // Kazakhstan
  KG: 'ru', // Kyrgyzstan
  
  // Default to English for all other countries
  DEFAULT: 'en'
} as const;

export async function detectUserLocation(): Promise<GeoResponse> {
  try {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 5000);

    const response = await fetch('https://ipapi.co/json/', {
      signal: controller.signal
    });
    
    clearTimeout(timeoutId);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    return {
      country_code: data.country_code || 'DEFAULT',
      country_name: data.country_name || 'Unknown',
      ip: data.ip || 'Unknown'
    };
  } catch (error) {
    console.warn('Failed to detect location:', error);
    return {
      country_code: 'DEFAULT',
      country_name: 'Unknown',
      ip: 'Unknown'
    };
  }
}

export function getLanguageFromCountry(countryCode: string): Language {
  return COUNTRY_LANGUAGE_MAP[countryCode] || COUNTRY_LANGUAGE_MAP.DEFAULT;
}